<template>
<div id="name_attestation" class="name_attestation">
	<!-- <div class="location">
		<p>当前位置：</p>
		<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
		实名认证
	</div> -->
    <div class="uinfo" style="margin-top: 0;">
        <div class="titBox">
            <p class="tit">身份认证</p>
			<el-button style=" float: right;" size="small" type="primary"
			 v-if="!(save_file_url[17]==st_document||save_file_url[15]==yangbenzheng||save_file_url[16]==yangbenfan) && !ruleForm.certified"
			 @click="confirm_information">提交认证</el-button>
        </div>
        <ul class="document_list">
            <li id="idcard">
                <p class="require"><b>身份证</b>要求：包含正面、反面，上传文件为jpg格式，文件大小在10M以内</p>
                <div class="file_preview_box">
                    <div class="file_preview">
                        <img :src="save_file_url[15]" alt="身份证正面" class="idcard_img1" />
                    </div>
                    <div class="document_data_ctrl">
                        <el-upload
                            class="upload-demo"
                            action="#"
                            :limit="1"
                            :auto-upload="false"
						    :on-exceed="handle_exceed"
                            :show-file-list="false"
                            :file-list="file_list_zheng">
							<!-- v-if="save_file_url[15]==yangbenzheng" -->
                            <el-button v-if="!ruleForm.certified" size="small" type="primary">上传身份证正面</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="file_preview_box">
                    <div class="file_preview">
                        <img :src="save_file_url[16]" alt="身份证反面" class="idcard_img2" />
                    </div>
                    <div class="document_data_ctrl">
						<el-upload
                            class="upload-demo"
                            action="#"
                            :limit="1"
                            :auto-upload="false"
						    :on-exceed="handle_exceed_fan"
                            :show-file-list="false"
                            :file-list="file_list_zheng">
							 <!-- v-if="save_file_url[16]==yangbenfan" -->
                            <el-button v-if="!ruleForm.certified" size="small" type="primary">上传身份证反面</el-button>
                        </el-upload>
                        <!-- <button class="layui-btn layui-btn-sm upload" file-type="2">上传身份证反面</button> -->
                    </div>
                </div>
            </li>
            <li id="user_photo">
                <p class="require"><b>人脸识别</b>要求：正面对摄像头，保持光线充足</p>
                <div class="file_preview_box">
                    <div class="file_preview">
                        <img :src="save_file_url[17]" alt="证件照" class="user_photo_img" />
                    </div>
                    <div class="document_data_ctrl">
						 <!-- v-if="save_file_url[17]==st_document" -->
						<el-button v-if="!ruleForm.certified" size="small" type="primary" @click="face_recognition">点击验证人脸识别</el-button>
                        <!-- <button class="layui-btn layui-btn-sm upload" file-type="4">点击验证人脸识别</button> -->
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="uinfo">
        <div class="titBox">
            <p class="tit">个人信息</p>
        </div>
		<el-form :model="ruleForm" ref="ruleForm" class="uinfoForm">
			<el-form-item class="lineInput">
				<label class="labelTit">学生姓名</label>
				<el-input disabled v-model="ruleForm.uname" type="text" name="uname" id="uname" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">性别</label>
				<el-input disabled v-model="ruleForm.sex" type="text" name="sex" id="sex" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">出生日期</label>
				<el-input disabled v-model="ruleForm.birthDate" type="text" name="birthDate" id="birthDate" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">手机号码</label>
				<el-input disabled v-model="ruleForm.uphone" type="text" name="phone" id="phone" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">最高学历</label>
				<el-input disabled v-model="ruleForm.xueli" type="text" name="xueli" id="xueli" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">校区</label>
				<el-input disabled v-model="ruleForm.area" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">证件类型</label>
				<el-input disabled v-model="ruleForm.idcardType" type="text" name="idcardType" id="idcardType" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">证件号码</label>
				<el-input disabled v-model="ruleForm.idcard" type="text" name="idcard" id="idcard" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">政治面貌</label>
				<el-input disabled v-model="ruleForm.mianmao" type="text" name="mianmao" id="mianmao" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
                <label class="labelTit">民族</label>
				<el-input disabled v-model="ruleForm.minzu" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input>
			</el-form-item>
        </el-form>
    </div>
    <div class="xuejiInfo" v-if="hideType === 3">
        <div class="titBox">
            <p class="tit">学籍认证</p>
			<!-- <div class="titRightBox">
				<el-button class="yidong" plain>申请学籍异动</el-button>
			</div> -->
        </div>
		<el-form :model="ruleForm" ref="ruleForm" class="xuejiForm">
			<el-form-item class="lineInput">
				<label class="labelTit">报考学校</label>
				<el-input disabled v-model="ruleForm.school" type="text" name="school" id="school" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">年级</label>
				<el-input disabled v-model="ruleForm.nian" type="text" name="nian" id="nian" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学历层次</label>
				<el-input disabled v-model="ruleForm.cengci" type="text" name="cengci" id="cengci" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">报考专业</label>
				<el-input disabled v-model="ruleForm.zhuanye" type="text" name="zhuanye" id="zhuanye" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">班级</label>
				<el-input disabled v-model="ruleForm.banji" type="text" name="banji" id="banji" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学号</label>
				<el-input disabled v-model="ruleForm.xuehao" type="text" name="xuehao" id="xuehao" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学制</label>
				<el-input disabled v-model="ruleForm.xuezhi" type="text" name="xuezhi" id="xuezhi" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学籍状态</label>
				<el-input disabled v-model="ruleForm.xuejiSt" type="text" name="xuejiSt" id="xuejiSt" placeholder="暂无填写"></el-input>
			</el-form-item>
			<!-- <el-form-item class="lineInput">
				<label class="labelTit">异动审核状态</label>
				<el-input disabled v-model="ruleForm.yidong" type="text" name="yidong" id="yidong" placeholder="暂无填写"></el-input>
			</el-form-item> -->
        </el-form>
    </div>
	<el-dialog
		title="验证不通过"
		:visible.sync="dialogVisible"
		width="710px">
		<div>
			<span>不通过原因:</span>
			<span style="color: red;">上传的证件照片证件号与学籍证件号不匹配，请上传正确的证件照片或联系教务修改学籍信息</span>
		</div>
		<div>
			<span>上传的证件信息如下：</span>
		</div>
		<div>
			<span>姓名:</span>
			<span>{{cradInfo.words_result['姓名'].words}}</span>
		</div>
		<div>
			<span>性别:</span>
			<span>{{cradInfo.words_result['性别'].words}}</span>
		</div>
		<div>
			<span>民族:</span>
			<span>{{cradInfo.words_result['民族'].words}}</span>
		</div>
		<div>
			<span>身份证号:</span>
			<span>{{cradInfo.words_result['公民身份号码'].words}}</span>
		</div>
		<span slot="footer" class="dialog-footer">
		  <el-button @click="dialogVisible = false" type="primary">确定信息</el-button>
		</span>
	</el-dialog>
</div>
</template>

<script>
const yangbenzheng = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenzheng.png'
const yangbenfan = 'https://oss.test5184.com/520.test5184.com/entryForm/images/yangbenfan.png'
const st_document = 'https://oss.test5184.com/520.test5184.com/entryForm/images/st_document1.jpg'
function xuejiTxt(ji){
	switch (ji){
		case 1:
			return "在读"
		case 2:
			return "毕业"
		case 3:
			return "停学"
		case 4:
			return "退学"
	}
}
const OSS = require('ali-oss');
let client
export default {
	data () {
		// client = new OSS(Object.assign({
		// 	secure:true,
		// },this.global.new_oss))
		return {
			yangbenzheng:yangbenzheng,
			yangbenfan:yangbenfan,
			st_document:st_document,
			image_status_text:{
				'normal':'识别正常',
				'reversed_side':'身份证正反面颠倒',
				'non_idcard':'上传的图片中不包含身份证',
				'blurred':'身份证模糊',
				'other_type_card':'其他类型证照',
				'over_exposure':'身份证关键字段反光或过曝',
				'over_dark':'身份证欠曝（亮度过低）',
				'unknown':'未知状态',
			},
			file_list_zheng:[{name: '身份证正面',url:yangbenzheng}],
			loading:true,
			purchased_list: [],
            location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
                query:{page: this.$store.state.defaultIndex}
			},{
				title:"个人信息",
				router:"/web/userIndex/",
				name: 'userIndex',
				query:{page:'userIndex'}
			}],
            ruleForm: { //个人信息
				id:'',
				uname: '',
				uphone: '',
				area: '',
				email: '',
				school: '',
				grade: '',
				cengci: '',
				zhuanye: '',
				idcard:'',
				idcardInput:'',
				pass:'',
				checkPass:'',
				certified:false, //是否已经实名认证
			},
            save_file_url:{ //证件
                15:yangbenzheng,
                16:yangbenfan,
				17:st_document,
            },
			dialogVisible:false, //身份证不匹配弹窗
			cradInfo:{
				words_result:{
					'姓名':'',
					'性别':'',
					'民族':'',
					'公民身份号码':''
				}
			}
		}
	}
	,mounted:function(){
		window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
		var that = this
		// 初始化url对象
        var url = new URL(window.location.href);
        // 解析response
        var response = {}
		if (url.searchParams.get('response')) {
			response = JSON.parse(
        	    decodeURIComponent(url.searchParams.get('response'))
        	);
		}
		// console.log(response);
		this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/aliyun/confirm_information_details")
		.then(res=>{
			// console.log(res);
			let resData=res.data;
			if(resData.code==0){
				if (resData.data.id_card_front) {
					that.save_file_url[15] =  this.global.oss_link+resData.data.id_card_front
				}
				if (resData.data.id_card_back) {
					that.save_file_url[16] = this.global.oss_link+resData.data.id_card_back
				}
				if (resData.data.authentication_avatar) {
					that.save_file_url[17] = this.global.oss_link+resData.data.authentication_avatar
				}
				// !resData.data.authentication_avatar
				if (response.extInfo) {
					let data = {
						certifyId:response.extInfo.certifyId
					}
					this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/finance_describe_face_verify",this.$qs.stringify(data))
		    		.then(res=>{
						// console.log(res);
						let resData=res.data.data;
						if(resData.Code=='200'){
							resData.ResultObject.MaterialInfo = JSON.parse(resData.ResultObject.MaterialInfo)
							// console.log(resData);
							if (resData.ResultObject.Passed=='T') {//通过
								console.log(resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl);
								that.getBase64(null,resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl).then(result => {
									that.upLoad(result,17)
								});
							}else{//未通过
								this.$message.error('认证未通过')
							}
						}else{
							this.$message.error(resData.Message)
						}
		    		}).catch(_ => {
						this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					});
				}
			}else{

			}
		}).catch(_ => {
			this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
		});


		this.$selfjs.getUserCallFn(this, function(res){ //获取个人信息
			let idcard = res.idcard,
				idcardType = '身份证'
			that.ruleForm.uname=res.nick_name					//学生姓名
			that.ruleForm.id = res.id
			that.ruleForm.sex=that.$selfjs.getSex(idcard)	//性别
			that.ruleForm.birthDate=that.$selfjs.getBirth(idcard)	//出生日期
			that.ruleForm.uphone=res.mobile						//手机号码
			that.ruleForm.xueli=res.max_education				//最高学历
			that.ruleForm.area=res.student_from					//校区
			that.ruleForm.idcard=idcard						//证件号码
			that.wx_name=res.wx_name						//微信昵称
			that.unionid=res.unionid						//微信unionid
			if(idcard.length <= 15){
				idcardType = '其他'
			}
			that.ruleForm.idcardType = idcardType					//证件类型
			that.ruleForm.mianmao=res.polit_face				//政治面貌
			that.ruleForm.minzu=res.nation						//民族
			// that.ruleForm.email=res.email
			that.ruleForm.school=res.school.school_name			//报考学校
			that.ruleForm.nian=res.grade.grade_name				//年级
			that.ruleForm.cengci=that.$store.state.const.major_level.find(v=>{ return v.id == res.major.major_level}).value			//学历层次
			that.ruleForm.zhuanye=res.major.major_name			//报考专业
			that.ruleForm.banji=res.grade.grade_name			//班级
			that.ruleForm.xuehao=res.student_sn					//学号
			that.ruleForm.xuezhi=res.student_system				//学制
			that.ruleForm.xuejiSt=xuejiTxt(res.student_status)			//学籍状态
			that.ruleForm.yidong=res.yidong || "未申请"	//异动审核状态
			that.ruleForm.certified=res.certified
		})
	}
	,methods:{
		//人脸验证
		face_recognition(){
			if (this.save_file_url[15]==yangbenzheng||this.save_file_url[16]==yangbenfan) {
				this.$message.error('请上传身份证')
				return false
			}
			// 在调用实人认证服务端发起认证请求时需要传入该MetaInfo值
        	var MetaInfo = window.getMetaInfo();
			console.log(window.getMetaInfo());
			let data = {
				certName:this.ruleForm.uname,
				certNo:this.ruleForm.idcard,
				metaInfo:MetaInfo,
				returnUrl:this.global.serverSrc+`/web/#/web/name_attestation`,
				// returnUrl:'https://404xuexi.test5184.com/web/#/web/name_attestation',
				// returnUrl:'https://xuexi.qsxueli.com/web/#/web/name_attestation'
			}
			// 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        	if (navigator.mediaDevices === undefined) {
				navigator.mediaDevices = {}
        	}
        	// 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        	// 使用getUserMedia，因为它会覆盖现有的属性。
        	// 这里，如果缺少getUserMedia属性，就添加它。
        	if (navigator.mediaDevices.getUserMedia === undefined) {
				// console.log(6);
				navigator.mediaDevices.getUserMedia = function (constraints) {
					// console.log(7);
					// 首先获取现存的getUserMedia(如果存在)
					var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
					// 有些浏览器不支持，会返回错误信息
					// 保持接口一致
					if (!getUserMedia) {
						// console.log(8);
						return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
					}
					// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
					return new Promise(function (resolve, reject) {
						getUserMedia.call(navigator, constraints, resolve, reject)
					})
				}
        	}
        	var constraints = { audio: false, video: { width: 100, height: 100, transform: 'scaleX(-1)' } }
        	navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/finance_contrast_face_verify",this.$qs.stringify(data))
		    	.then(res=>{
					let resData=res.data.data;
					if(resData.Code=='200'){
						window.location.href = resData.ResultObject.CertifyUrl
					}else{
						this.$message.error(resData.MessageText)
					}
					loading.close()
		    	}).catch(_ => {
					loading.close()
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
        	}).catch((err) => {
				console.log(err)
				this.camera = 0
				this.$message.error("无法检测到摄像头。如果已经插入摄像头,请允许浏览器使用摄像头的权限")
        	})

			
		},
        before_upload(file){
			console.log(6);
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			console.log(file)
			// return false
			// let that = this
			// 	,test_id = this.$route.query.test_id
			// 	,del_file = false
			// 	,key = this.upload_img_info.key
			// 	,ti_index = this.upload_img_info.ti_index
			// if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
			// 	this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
			// 		confirmButtonText: '确定'
			// 	})
			// 	del_file = true;
			// }
			// if(file.size > 512000){
			// 	this.$alert('图片大小不能超过500KB', '信息提示', {
			// 		confirmButtonText: '确定'
			// 	})
			// 	del_file = true;
			// }
			// //验证不通过，删除显示的文件
			// if(del_file){
			// 	fileList.splice(fileList.length-1, 1)
			// }else{
			// 	const loading = this.$loading({
			// 		lock: true,
			// 		text: 'Loading',
			// 		spinner: 'el-icon-loading',
			// 		background: 'rgba(0, 0, 0, 0.7)'
			// 	});
			// 	//验证通过，上传图片
			// 	let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
			// 	client.put(upload_path, file.raw)
			// 	.then((res)=>{
			// 		// console.log(res);
			// 		if(res.res && res.res.statusCode == 200){
			// 			// console.log(file.name+'--------上传成功')
			// 			that.testForm[key][ti_index].answer_img.push({
			// 				uid:file.uid
			// 				,url:res.url
			// 				,name:res.name
			// 				,file_name:file.name
			// 			})
			// 		}else{
			// 			that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
			// 				confirmButtonText: '确定',
			// 			});
			// 			fileList.splice(fileList.length-1, 1)
			// 		}
			// 		loading.close()
			// 	})
			// 	.catch((err)=> {
			// 		console.log (err);
			// 		that.$alert(file.name+'上传出错！！前联系教务老师或管理员', '信息提示', {
			// 			confirmButtonText: '确定',
			// 		});
			// 		fileList.splice(fileList.length-1, 1)
			// 		loading.close()
			// 	});
			// }
		},
		upimg(file,sdtype){
			let Base64 = ''
			if (file.length>1) {
				this.$message.warning('只能传一张')
				return false
			}
			if(file[0].type != "image/jpg" && file[0].type != "image/jpeg" && file[0].type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				return false
			}
			if(file.size > 10240000){
				this.$alert('图片大小不能超过10m', '信息提示', {
					confirmButtonText: '确定'
				})
				return false
			}
			this.getBase64(file[0]).then(result => {
				Base64 = result.replace(/^data:image\/\w+;base64,/, "")
				this.id_card_identification(Base64,sdtype,file[0])
			})
		},
        handle_exceed(file){ //文件超出回调，用于身份证上传
			this.upimg(file,15)
		},
		handle_exceed_fan(file){
			this.upimg(file,16)
		},
		//身份证校验
		id_card_identification(base64,sdtype,file){
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let that = this
			//用于身份证裁剪及提取信息进行比对
            this.$ajax.post(serverSrc + qianzui + "/aliyun/id_card_identification",this.$qs.stringify({
				image_base64:base64,
				id_card_side:sdtype==15?'back':'front'
			}))
		    .then(res=>{
				let resData=res.data.data;
				if (resData.risk_type=='normal') {
					if (resData.image_status=='normal') {
						let base64_card_image = resData.card_image
						if (sdtype==16) {
							that.cradInfo = resData
							// that.dialogVisible = true
							if (that.ruleForm.idcard+''===resData.words_result['公民身份号码'].words&&that.ruleForm.uname===resData.words_result['姓名'].words) {
								that.upLoad('data:image/jpeg;base64,'+base64_card_image,16,file)
							}else{
								that.dialogVisible = true
							}
						}else{
							that.upLoad('data:image/jpeg;base64,'+base64_card_image, 15,file)
						}
					}else{
						that.$message.error(that.image_status_text[resData.image_status])
					}
				}else{
					that.$message.error('请上传正确身份证！')
				}
				loading.close()
		    }).catch(_ => {
				loading.close()
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		// 转base64
    	getBase64(file,imgUrl) {
			if (file) {
				// 获取到文件对象
            	var file = file;
            	// 获取FileReader实例
            	var reader = new FileReader();
            	// 将文件加载进入
            	reader.readAsDataURL(file);
	
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					reader.onload = function (e) { 
            		    // 转换完成输出该文件base64编码
						resolve(this.result);
            		}
				});
				return promise
			}else{
				let image = new Image();
      			// 解决跨域问题
      			image.setAttribute("crossOrigin", "anonymous");
      			let imageUrl = imgUrl;
      			image.src = imageUrl;
      			// image.onload为异步加载
      			// eslint-disable-next-line no-undef
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					image.onload = function() {
      				  	var canvas = document.createElement("canvas");
      				  	canvas.width = image.width;
      				  	canvas.height = image.height;
      				  	var context = canvas.getContext("2d");
      				  	// eslint-disable-next-line no-undef
      				  	context.drawImage(image, 0, 0, image.width, image.height);
      				  	var quality = 1;
      				  	// 这里的dataurl就是base64类型
      				  	// 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      				  	let dataurl = canvas.toDataURL("image/jpeg", quality);
      				  	// sBase64 = dataurl
						resolve(dataurl);
      				};
				});
				return promise
			}
			
		},
        //点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//上传
		upLoad(base64,sdtype){
			let that = this
			let file = that.base64toFile(base64)
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let flname = this.$selfjs.createOssFileName()
			if (sdtype==15||sdtype==16) {
				flname = sdtype==15?'yangbenzheng':'yangbenfan'
			}
			//验证通过，上传图片
			let upload_path = `xuexi.qsxueli.com/uploadFile/student/documents/${that.ruleForm.id}/${flname}.${file.name.substring(file.name.lastIndexOf(".")+1)}`;
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/student/documents/'+that.ruleForm.id}))
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file);
					
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						// console.log(res);
						if (res.ok) {
							// console.log(sdtype);
							that.save_file_url[sdtype] = that.global.oss_link + upload_path
							// console.log(that.save_file_url);
							if (sdtype==15||sdtype==16) {
								if (that.save_file_url[15]!=yangbenzheng&&that.save_file_url[16]!=yangbenfan) {
									that.aliyun_compare_identity()
								}
							}else if (sdtype==17) {
								that.confirm_information_updated({authentication_avatar:upload_path})
							}
						}else{
							that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
							fileList.splice(fileList.length-1, 1)
						}
					})
				}else{
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
				}
				loading.close()
		    }).catch(_ => {
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		//base64转文件
		base64toFile (dataurl, filename = 'file') {
		    let arr = dataurl.split(',')
		    let mime = arr[0].match(/:(.*?);/)[1]
		    let suffix = mime.split('/')[1]
		    let bstr = atob(arr[1])
		    let n = bstr.length
		    let u8arr = new Uint8Array(n)
		    while (n--) {
		        u8arr[n] = bstr.charCodeAt(n)
		    }
		    return new File([u8arr], `${filename}.${suffix}`, {
		        type: mime
		    })

		},
		//身份证识别
		aliyun_compare_identity(){
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/aliyun/aliyun_compare_identity",{},{
				CertUrl:this.save_file_url[16],
				CertNationalEmblemUrl:this.save_file_url[15]
			})
		    .then(res=>{
				let resData=res.data.data;
				if(resData.Code=='200'){
					if (resData.ResultObject.SubCode==200) {
						this.confirm_information_updated({id_card_front:this.save_file_url[15].replace(this.global.oss_link, ""),id_card_back:this.save_file_url[16].replace(this.global.oss_link, "")})
					}else{
						this.$message.error('请传入正确的证件！')
						this.save_file_url[16] = yangbenfan
						this.save_file_url[15] = yangbenzheng
					}
				}else{
					this.save_file_url[16] = yangbenfan
					this.save_file_url[15] = yangbenzheng
					this.$message.error(resData.Message)
				}
				loading.close()
		    }).catch(_ => {
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		//认证成功存数据库
		confirm_information_updated(data){
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/confirm_information_updated",this.$qs.stringify(data))
		    .then(res=>{
				let resData=res.data;
				// console.log(resData);
				if (resData.code==0) {
					// this.$selfjs.errshow('提交成功')
					if (data.authentication_avatar) {
						this.certified_dlog_fn()
					}
				}else{
					if (data.authentication_avatar) {
						this.save_file_url[17] = st_document
					}else{
						this.save_file_url[16] = yangbenfan
						this.save_file_url[15] = yangbenzheng
					}
					this.$message.error('提交失败')
				}
				loading.close()
		    }).catch(_ => {
				if (data.authentication_avatar) {
					this.save_file_url[17] = st_document
				}else{
					this.save_file_url[16] = yangbenfan
					this.save_file_url[15] = yangbenzheng
				}
				loading.close()
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//提交认证
		confirm_information(){
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/confirm_information",this.$qs.stringify({
				authentication_avatar:this.save_file_url[17].replace(this.global.oss_link, ""),
				id_card_front:this.save_file_url[15].replace(this.global.oss_link, ""),
				id_card_back:this.save_file_url[16].replace(this.global.oss_link, "")
			}))
		    .then(res=>{
				let resData=res.data;
				// console.log(resData);
				if (resData.code==0) {
					this.ruleForm.certified = true
					this.global.uDetailData.certified = true
					this.$alert('认证成功', '提示', {
						confirmButtonText: '确定',
						type: 'success',
						callback: action => {
							window.location.href="/web/#/web/userIndex/"
						}
					});
				}else{
					this.$message.error('认证失败')
				}
				loading.close()
		    }).catch(_ => {
				loading.close()
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//弹框
		certified_dlog_fn(){
			this.$alert('认证成功', '提示', {
        	  	confirmButtonText: '确定',
				showClose:false,
        	  	callback: action => {
					window.history.pushState( {}, '', '/web/#/web/name_attestation' )
					// window.location.href="/web/#/web/name_attestation"
        	  	}
        	});
		}
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/userCenter/name_attestation.vue